import React, { useEffect, useState } from "react";
import { Grid, CircularProgress } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";

const ListaMisterio = () => {
    const [imagenes, setImagenes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchImagenes = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "misterio"));
                const data = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                data.sort((a, b) => {
                    if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                    if (a.orden !== undefined) return -1;
                    if (b.orden !== undefined) return 1;
                    return 0;
                });
                setImagenes(data);
            } catch (error) {
                console.error("❌ Error cargando imágenes de misterio:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchImagenes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", minHeight: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            size={{ xs: 12, sm: 12, md: 12 }}
            justifyContent="center"
            alignItems={'flex-start'}
            sx={{ width: "100%", pt: 9, pb: 4 }}
            spacing={0}
        >
            {imagenes.map((img) => (
                <Grid
                    container
                    alignItems={'flex-start'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                    key={img.id}
                    sx={{ justifyContent: "center", mb: 0 }}
                >
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{ xs: 12, sm: 8, md: 5 }}
                    >
                        <img
                            src={img.url}
                            alt={img.nombre || "imagen misterio"}
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                            }}
                        />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default ListaMisterio;